import { Market } from '@bridebook/toolbox/src/gazetteer';
import { UrlHelper } from '@bridebook/web/lib/url-helper';

/* DownloadAppBanner exclude pages */
export const EXCLUDE_DOWNLOAD_APP_BANNER_PAGES = [
  '/_error',
  UrlHelper.signup,
  UrlHelper.onboarding,
  UrlHelper.inbox.main,
  UrlHelper.brochures,
];

export const shouldExcludeDownloadAppBanner = (asPath: string, market: Market) =>
  EXCLUDE_DOWNLOAD_APP_BANNER_PAGES.some((page) => asPath.startsWith(`/${market.prefix}${page}`));
